import React from "react"
import HeaderComponent from "../Header/component"
import FooterComponent from "../Footer/component"

import "./styles.scss"

export default function NewsSinglePostComponent() {
  return (
    <>
      <HeaderComponent />

      <main id="main" className="site-main">
        <div id="page-title" className="page-title-ml">
          <div className="wrapper">
            <div className="title">
              <h1 className="large">Our News</h1>
            </div>

            <div className="title-opacity">
              <div className="title-opacity-text">News</div>
            </div>
          </div>
        </div>

        <div id="page-content" className="spacer p-top-xl">
          <div className="wrapper">
            <div className="content">
              <div id="single">
                <div className="row gutter-width-md">
                  <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 single-content">
                    <div className="img object-fit">
                      <div className="object-fit-cover">
                        <img
                          src="assets/img/demo/21_img.jpg"
                          alt="Assessing the Maturity of Your Data Management in Industry"
                        />
                      </div>
                    </div>

                    <div className="meta">
                      <p>
                        <span>
                          <a href="news.html">By admin</a>
                        </span>
                        <span>-</span>
                        <span>Comments (1)</span>
                        <span>-</span>
                        <span className="category">
                          <a title="Business" href="news.html">
                            Business
                          </a>
                        </span>
                      </p>
                    </div>

                    <div className="title">
                      <h2>
                        Assessing the Maturity of Your Data Management in
                        Industry
                      </h2>
                    </div>

                    <div className="description clearfix">
                      <p>
                        But I must explain to you how all this mistaken idea of
                        denouncing pleasure and praising pain was born and I
                        will give you a complete account of the system, and
                        expound the actual teachings of the great explorer of
                        the truth, the master-builder of human happiness.
                      </p>

                      <p>
                        No one rejects, dislikes, or avoids pleasure itself,
                        because it is pleasure, but because those who do not
                        know how to pursue pleasure rationally encounter
                        consequences that are extremely painful. Nor again is
                        there anyone who loves or pursues or desires to obtain
                        pain of itself, because it is pain, but because
                        occasionally circumstances occur in which toil and pain
                        can procure him some great pleasure.
                      </p>

                      <blockquote>
                        <p>
                          To take a trivial example, which of us ever undertakes
                          laborious physical exercise, except to obtain some
                          advantage from it?
                        </p>
                      </blockquote>

                      <p>
                        No one rejects, dislikes, or avoids pleasure itself,
                        because it is pleasure, but because those who do not
                        know how to pursue pleasure rationally encounter
                        consequences that are extremely painful.
                      </p>
                    </div>

                    <div className="tags">
                      <p>
                        <a title="Strategy" href="news.html">
                          Strategy
                        </a>
                        <a title="Sales" href="news.html">
                          Sales
                        </a>
                        <a title="Business" href="news.html">
                          Business
                        </a>
                      </p>
                    </div>

                    <div
                      id="comments"
                      className="comments-area spacer m-top-xl"
                    >
                      <div className="comment-title">
                        <h3>1 Comment</h3>
                      </div>

                      <ul className="comment-list list-unstyled style-default">
                        <li className="comment">
                          <div className="comment-wrapper">
                            <div className="comment-details">
                              <div className="comment-content">
                                <div className="comment-content-left">
                                  <div className="comment-img">
                                    <img
                                      src="assets/img/demo/19_img.png"
                                      alt="Rosie Ford"
                                    />
                                  </div>
                                </div>

                                <div className="comment-content-right">
                                  <h5 className="comment-author after">
                                    <a
                                      title="Rosie Ford"
                                      href="news-single-post.html"
                                    >
                                      Rosie Ford
                                    </a>
                                  </h5>

                                  <div className="comment-time">
                                    <p>29 February, 2022 3:23 pm</p>
                                  </div>

                                  <div className="comment-description">
                                    <p>
                                      No one rejects, dislikes, or avoids
                                      pleasure itself, because it is pleasure,
                                      but because those who do not know how to
                                      pursue pleasure rationally.
                                    </p>
                                  </div>

                                  <div className="comment-reply">
                                    <a
                                      title="Reply"
                                      className="btn btn-sm btn-link btn-icon p-0 border-0 min-w-auto link-no-space text-uppercase scroll-to-id"
                                      href="#reply-title"
                                    >
                                      <i className="malex-icon-arrow-right i-large"></i>
                                      <span className="btn-text">Reply</span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>

                      <div className="block spacer m-top-xl">
                        <div id="respond" className="comment-respond">
                          <h3 id="reply-title" className="comment-reply-title">
                            Leave a Reply{" "}
                            <a
                              rel="nofollow"
                              id="cancel-comment-reply-link"
                              className="btn btn-link border-0 p-0 min-w-auto link-no-space"
                              href="news-single-post.html"
                              style={{ display: 'none' }}
                            >
                              Cancel Reply
                            </a>
                          </h3>

                          <form
                            action="https://store.adveits.com/project/malex/html/demo/form.php"
                            method="post"
                            id="commentform"
                            className="comment-form"
                          >
                            <div className="form-group form-group-sm">
                              <p className="comment-notes">
                                Your email address will not be published.
                                Required fields are marked{" "}
                                <span className="required">*</span>
                              </p>
                            </div>

                            <div className="form-group form-group-xs">
                              <textarea
                                id="comment"
                                className="form-control form-control-lg"
                                name="comment"
                                cols="45"
                                rows="6"
                                placeholder="Comment *"
                                required="required"
                              ></textarea>
                            </div>

                            <div className="form-group form-group-xs">
                              <input
                                id="comment-author"
                                className="form-control form-control-lg"
                                name="comment-author"
                                type="text"
                                placeholder="Name *"
                                required="required"
                              />
                            </div>

                            <div className="form-group form-group-xs">
                              <input
                                id="comment-email"
                                className="form-control form-control-lg"
                                name="comment-email"
                                type="email"
                                placeholder="Email *"
                                required="required"
                              />
                            </div>

                            <div className="form-group form-group-sm">
                              <input
                                id="comment-url"
                                className="form-control form-control-lg"
                                name="comment-url"
                                placeholder="Website"
                                type="url"
                              />
                            </div>

                            <div className="form-group form-group-sm">
                              <p className="comment-form-cookies-consent custom-control custom-checkbox">
                                <input
                                  id="wp-comment-cookies-consent"
                                  className="custom-control-input"
                                  name="wp-comment-cookies-consent"
                                  type="checkbox"
                                  value="yes"
                                />
                                <label
                                  className="custom-control-label"
                                  for="wp-comment-cookies-consent"
                                >
                                  Save my name, email, and website in this
                                  browser for the next time I comment.
                                </label>
                              </p>
                            </div>

                            <div className="form-submit">
                              <input
                                name="submit"
                                type="submit"
                                className="btn btn-outline-secondary"
                                value="Post Comment"
                              />
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                    <aside id="aside" className="widget-area">
                      <div className="widget widget_search">
                        <form
                          className="search-form"
                          role="search"
                          method="get"
                          action="https://store.adveits.com/project/malex/html/demo/search-results.html"
                        >
                          <div className="search input-group">
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              placeholder="Search"
                              name="s"
                            />

                            <div className="input-group-append">
                              <button
                                type="submit"
                                className="btn btn-link border-0 p-0 min-w-auto"
                              >
                                <i className="fas fa-search"></i>
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div className="widget widget_categories">
                        <h6 className="widget-title">Categories</h6>

                        <ul>
                          <li className="cat-item">
                            <a title="Strategy" href="news.html">
                              Strategy
                            </a>
                          </li>

                          <li className="cat-item">
                            <a title="Sales" href="news.html">
                              Sales
                            </a>
                          </li>

                          <li className="cat-item">
                            <a title="Marketing" href="news.html">
                              Marketing
                            </a>
                          </li>

                          <li className="cat-item">
                            <a title="Business" href="news.html">
                              Business
                            </a>
                          </li>
                        </ul>
                      </div>

                      <div className="widget widget_recent_entries">
                        <h6 className="widget-title">Recent posts</h6>

                        <ul className="list-unstyled items">
                          <li className="item">
                            <div className="row gutter-width-xs">
                              <div className="col-3">
                                <a href="news-single-post.html">
                                  <div className="img object-fit overflow-hidden">
                                    <div className="object-fit-cover transform-scale-h">
                                      <img
                                        src="assets/img/demo/15_img.jpg"
                                        alt="5 Tips for Sustainable Business Success"
                                      />
                                    </div>
                                  </div>
                                </a>
                              </div>

                              <div className="col-9 align-self-center">
                                <p className="item-t-head">
                                  <a
                                    title="5 Tips for Sustainable Business Success"
                                    href="news-single-post.html"
                                  >
                                    5 Tips for Sustainable Business Success
                                  </a>
                                </p>
                              </div>
                            </div>
                          </li>

                          <li className="item">
                            <div className="row gutter-width-xs">
                              <div className="col-3">
                                <a href="news-single-post.html">
                                  <div className="img object-fit overflow-hidden">
                                    <div className="object-fit-cover transform-scale-h">
                                      <img
                                        src="assets/img/demo/16_img.jpg"
                                        alt="Assessing the Maturity of Your Data Management in Industry"
                                      />
                                    </div>
                                  </div>
                                </a>
                              </div>

                              <div className="col-9 align-self-center">
                                <p className="item-t-head">
                                  <a
                                    title="Assessing the Maturity of Your Data Management in Industry"
                                    href="news-single-post.html"
                                  >
                                    Assessing the Maturity of Your Data
                                    Management in Industry
                                  </a>
                                </p>
                              </div>
                            </div>
                          </li>

                          <li className="item">
                            <div className="row gutter-width-xs">
                              <div className="col-3">
                                <a href="news-single-post.html">
                                  <div className="img object-fit overflow-hidden">
                                    <div className="object-fit-cover transform-scale-h">
                                      <img
                                        src="assets/img/demo/17_img.jpg"
                                        alt="How to Build Your Sustainable Susiness Strategy"
                                      />
                                    </div>
                                  </div>
                                </a>
                              </div>

                              <div className="col-9 align-self-center">
                                <p className="item-t-head">
                                  <a
                                    title="How to Build Your Sustainable Susiness Strategy"
                                    href="news-single-post.html"
                                  >
                                    How to Build Your Sustainable Susiness
                                    Strategy
                                  </a>
                                </p>
                              </div>
                            </div>
                          </li>

                          <li className="item">
                            <div className="row gutter-width-xs">
                              <div className="col-3">
                                <a href="news-single-post.html">
                                  <div className="img object-fit overflow-hidden">
                                    <div className="object-fit-cover transform-scale-h">
                                      <img
                                        src="assets/img/demo/15_img.jpg"
                                        alt="5 Tips for Sustainable Business Success"
                                      />
                                    </div>
                                  </div>
                                </a>
                              </div>

                              <div className="col-9 align-self-center">
                                <p className="item-t-head">
                                  <a
                                    title="5 Tips for Sustainable Business Success"
                                    href="news-single-post.html"
                                  >
                                    5 Tips for Sustainable Business Success
                                  </a>
                                </p>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div className="widget widget_recent_comments">
                        <h6 className="widget-title">Recent Comments</h6>

                        <ul id="recentcomments">
                          <li className="recentcomments">
                            <span className="comment-author-link">
                              Tommy Andersen
                            </span>{" "}
                            on
                            <a
                              title="Tommy Andersen"
                              href="news-single-post.html#comments"
                            >
                              Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit…
                            </a>
                          </li>

                          <li className="recentcomments">
                            <span className="comment-author-link">
                              Rosie Ford
                            </span>{" "}
                            on
                            <a
                              title="Rosie Ford"
                              href="news-single-post.html#comments"
                            >
                              Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit…
                            </a>
                          </li>

                          <li className="recentcomments">
                            <span className="comment-author-link">
                              Arthur Hopin
                            </span>{" "}
                            on
                            <a
                              title="Arthur Hopin"
                              href="news-single-post.html#comments"
                            >
                              Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit…
                            </a>
                          </li>
                        </ul>
                      </div>

                      <div className="widget widget_tag_cloud">
                        <h6 className="widget-title">Tags</h6>

                        <div className="tagcloud">
                          <a
                            title="Strategy"
                            href="news.html"
                            className="tag-cloud-link"
                          >
                            Strategy
                          </a>
                          <a
                            title="Marketing"
                            href="news.html"
                            className="tag-cloud-link"
                          >
                            Marketing
                          </a>
                          <a
                            title="Sales"
                            href="news.html"
                            className="tag-cloud-link"
                          >
                            Sales
                          </a>
                          <a
                            title="Business"
                            href="news.html"
                            className="tag-cloud-link"
                          >
                            Business
                          </a>
                        </div>
                      </div>
                    </aside>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <FooterComponent />
    </>
  )
}
